import ApiClient from './ApiClient';

class AutomationRuleFoldersAPI extends ApiClient {
  constructor() {
    super('automation_rule_folders', { accountScoped: true });
  }
}

export default new AutomationRuleFoldersAPI();
